export const isValueInRange = (x: number, min: number, max: number) =>
  x >= min && x <= max;
